import {useEffect} from 'react';

// Define excluded selectors that should not trigger the outside click handler
const EXCLUDED_SELECTORS = [
    '[data-cy*="userMessage"]',
    // Phone input dropdown elements
    '.countries-list',
    '.phone-container',
    // Add more selectors here as needed
    // '.popup-content',
    // '.modal-overlay',
];

const UseMouseUpOutside = (ref, handler) => {
    useEffect(
        () => {
            const listener = (event) => {
                if(!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                
                // Check if the event target matches any of the excluded selectors
                for(const selector of EXCLUDED_SELECTORS) {
                    const excludedElement = event.target.closest(selector);
                    if(excludedElement) {
                        return;
                    }
                }
                
                handler(event);
                
            };
            document.addEventListener('mouseup', listener);
            return () => {
                document.removeEventListener('mouseup', listener);
            };
        },
        [ref, handler]
    );

};

export default UseMouseUpOutside;